import numeral from "numeral";
import { getDecimal } from "../../util";
import useSuntekSettings from "../../hooks/useSuntekSettings";
import { formatDateTime } from "../../dateUtils";

export function nullableCheckBoxValue(value: any) {
  return value ? 'checked' : '';
}

export function intAsCheckBoxValue(value : any) {
  return value === 1 ? 'checked' : '';
}

export function CurrencyAmountValue(currencyAccessor:any, value:any) {
  const currency = currencyAccessor;
  let amount = '';
  const cellValue = value;
  const decimals = getDecimal(currency);
  if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
    const format = `0,0.${'0'.repeat(decimals)}`;
    amount = numeral(cellValue.toFixed(decimals)).format(format);
  }

  return amount;
}

export function Decimalformat(value : any, decimalFormat : any){
  if(!!value) value = value;
  else value = 0;
  return value.toFixed(decimalFormat);
}

export function DateTimeSecond(value: any,) {
  const suntekSettings = useSuntekSettings();
  return formatDateTime(value, suntekSettings.company?.dateFormat.toUpperCase() || '', true, true)
}

export function TaxIdType(cellvalue:any) {
  let value = '';

  if (cellvalue === 'E') {
    value = 'EIN - IRS Number';
  } else if (cellvalue === 'C') {
    value = 'CBP - CBP Assigned Number';
  } else if (cellvalue === 'S') {
    value = 'SSN - Social Security Number';
  } else if (cellvalue === 'O') {
    value = 'OC - Organization Code';
  } else if (cellvalue === 'U') {
    value = 'USCI - United Social Credit Identifier';
  } else if (cellvalue === 'R') {
    value = 'EORI - Economic Operator Reg. ID';
  }

  return value ;
}

export function paidValue(cell:any) {
  return cell !== 'x' ? 'checked' : '' ;
}

export function CustomerTypeValue(cellvalue:any) {
  let value = '';

  if (cellvalue === 'C') {
    value = 'C';
  } else if (cellvalue === 'ST') {
    value = 'ST';
  } else if (cellvalue === 'SF') {
    value = 'SF';
  } else if (cellvalue === 'SFST') {
    value = 'SF+';
  } else {
    value = 'C+';
  }

  return value ;
}